<div class="p-(--padding-card)">
  <ces-route-title [count]="units.length">
    <ces-menu-button icon="add" size="small" [label]="'common.buttons.add' | transloco" [items]="items()" />
  </ces-route-title>
  @if (loadFailed) {
    <div class="flex flex-col items-center gap-(--gap-normal) py-16 text-(--text-secondary)">
      <ces-icon size="xl" containerSize="md">error</ces-icon>
      <p>{{ 'common.errors.dataLoadFailed' | transloco }}</p>
      <ces-button [label]="'pages.errors.500.retry' | transloco" icon="refresh" (onClick)="loadData()" />
    </div>
  } @else {
    <p-tabs [(value)]="activeTab">
      <p-tablist>
        <p-tab value="0">{{ 'entities.unit.plural' | transloco }}</p-tab>
        <p-tab value="1">{{ 'entities.unit.type.plural' | transloco }}</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="0">
          <ces-generic-parent-grid
            (createEntity)="createUnit()"
            (editEntity)="editUnit($event)"
            (deleteEntity)="deleteUnit($event)"
            [dataLoadingCompleted]="dataLoadingCompleted"
            [entities]="units"
            [entityDefinition]="unitDefinition" />
        </p-tabpanel>
        <p-tabpanel value="1">
          <ces-generic-parent-grid
            (createEntity)="createUnitType()"
            (editEntity)="editUnitType($event)"
            (deleteEntity)="deleteUnitType($event)"
            [dataLoadingCompleted]="dataLoadingCompletedUnitType"
            [entities]="unitTypes"
            [entityDefinition]="unitTypeDefinition" />
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  }
</div>
